import * as React from 'react';
import OverviewBody from './OverviewBody';
const Overview = () => (React.createElement(OverviewBody, null));
export default Overview;
